module.exports = __webpack_public_path__ + "img/Icon_Bag_blue.00f73faf.svg";